(function () {
  if (window.__dmgLb) return;
  window.__dmgLb = true;
  var SEL = '.product__media-list .product-media-container';
  var svg = function (p, extra) {
    return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (extra || '') + '<path d="' + p + '"/></svg>';
  };
  var ic = {
    zoom: svg('M21 21l-4.3-4.3M11 8v6M8 11h6', '<circle cx="11" cy="11" r="7"/>'),
    prev: svg('M15 18l-6-6 6-6'),
    next: svg('M9 18l6-6-6-6'),
    close: svg('M6 6l12 12M18 6L6 18')
  };
  var box, img, count, bPrev, bNext, bClose, list = [], idx = 0, last = null, tx = null;

  function hi(s) {
    try {
      var u = new URL(s, location.href);
      u.searchParams.set('width', '2000');
      u.searchParams.delete('height');
      return u.toString();
    } catch (e) { return s; }
  }
  function collect() { list = [].slice.call(document.querySelectorAll(SEL + ' img')); }
  function addButtons() {
    [].forEach.call(document.querySelectorAll(SEL), function (h) {
      if (h.querySelector('.dmg-lb__zoom')) return;
      h.classList.add('dmg-lb-host');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dmg-lb__zoom';
      b.setAttribute('aria-label', 'Enlarge image');
      b.innerHTML = ic.zoom;
      h.appendChild(b);
    });
  }
  function mk(cls, label, html) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dmg-lb__btn ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = html;
    return b;
  }
  function build() {
    box = document.createElement('div');
    box.className = 'dmg-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image viewer');
    box.hidden = true;
    var stage = document.createElement('div');
    stage.className = 'dmg-lb__stage';
    img = document.createElement('img');
    img.className = 'dmg-lb__img';
    img.alt = '';
    stage.appendChild(img);
    count = document.createElement('div');
    count.className = 'dmg-lb__count';
    var bar = document.createElement('div');
    bar.className = 'dmg-lb__bar';
    bPrev = mk('dmg-lb__prev', 'Previous image', ic.prev);
    bClose = mk('dmg-lb__close', 'Close', ic.close);
    bNext = mk('dmg-lb__next', 'Next image', ic.next);
    bar.appendChild(bPrev); bar.appendChild(bClose); bar.appendChild(bNext);
    box.appendChild(stage); box.appendChild(count); box.appendChild(bar);
    document.body.appendChild(box);
    bPrev.addEventListener('click', function () { show(idx - 1); });
    bNext.addEventListener('click', function () { show(idx + 1); });
    bClose.addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box || e.target === stage) close(); });
    box.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (tx === null || list.length < 2) return;
      var dx = e.changedTouches[0].clientX - tx;
      tx = null;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
    });
  }
  function show(i) {
    idx = (i + list.length) % list.length;
    var el = list[idx];
    img.src = hi(el.currentSrc || el.src);
    img.alt = el.alt || '';
    var many = list.length > 1;
    count.textContent = (idx + 1) + ' / ' + list.length;
    count.hidden = !many;
    bPrev.hidden = !many;
    bNext.hidden = !many;
  }
  function open(i) {
    if (!list.length) return;
    if (!box) build();
    last = document.activeElement;
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    show(i);
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    bClose.focus();
  }
  function close() {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    box.hidden = true;
    document.body.style.overflow = '';
    img.removeAttribute('src');
    if (last && last.focus) last.focus();
  }
  document.addEventListener('click', function (e) {
    if (box && !box.hidden) return;
    var h = e.target.closest && e.target.closest(SEL);
    if (!h) return;
    var im = h.querySelector('img');
    collect();
    var i = list.indexOf(im);
    if (i < 0) return;
    e.preventDefault();
    open(i);
  });
  document.addEventListener('keydown', function (e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') { close(); }
    else if (e.key === 'ArrowLeft') { show(idx - 1); }
    else if (e.key === 'ArrowRight') { show(idx + 1); }
    else if (e.key === 'Tab') {
      var btns = [bPrev, bClose, bNext].filter(function (b) { return !b.hidden; });
      var pos = btns.indexOf(document.activeElement);
      e.preventDefault();
      pos = e.shiftKey ? (pos <= 0 ? btns.length - 1 : pos - 1) : (pos + 1) % btns.length;
      btns[pos].focus();
    }
  });
  addButtons();
  document.addEventListener('shopify:section:load', addButtons);
})();
